import React from "react";
import useSeverityAsPriority from "../../../../General/useSeverityAsPriority";
import { capitalize } from "lodash-es";

// This component takes no props today; exported so sibling charts can reference
// a stable type for the legend if/when props are introduced.
export type FindingsBySeverityLegendProps = Record<string, never>;

const FindingsBySeverityLegend: React.FC<
  FindingsBySeverityLegendProps
> = () => {
  const { currentSeverityMapping } = useSeverityAsPriority();

  return (
    <div className={"legend-container"}>
      {currentSeverityMapping?.map((severity) => (
        <div className={"legend-section"} key={`severity-${severity.name}`}>
          <span
            className={"legend-icon"}
            style={{ backgroundColor: severity.color }}
          />
          <span className={"legend-text"}>{capitalize(severity.name)}</span>
        </div>
      ))}
    </div>
  );
};

export default FindingsBySeverityLegend;
